<template>
  <div class="wrapper">
    <div class="redNotice" v-if="inRedNotice">
      <span>Vă rugăm să achitați facturile restante in cel mai scurt timp pentru a nu vi se suspenda accesul la panoul de control!</span>
    </div>
    <side-bar type="sidebar" :sidebar-links="$sidebar.sidebarLinks" class="noprint">
      <user-menu></user-menu>
<!--       <form class="navbar-form navbar-left navbar-search-form navbar-search-form-mobile" role="search">
        <div class="input-group">
          <span class="input-group-addon"><i class="fa fa-search"></i></span>
          <input type="text" value="" class="form-control" placeholder="Search...">
        </div>
      </form> -->
      <mobile-menu></mobile-menu>
    </side-bar>

    <div class="main-panel" id="mainContainer" v-loading.body.lock="fullscreenLoading">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar">

      </dashboard-content>

      <!-- <content-footer></content-footer> -->
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import UserMenu from 'src/components/UIComponents/SidebarPlugin/UserMenu.vue'
  import MobileMenu from 'src/components/UIComponents/SidebarPlugin/MobileMenu.vue'
  import Vue from 'vue'
  import {Loading} from 'element-ui'

  Vue.use(Loading.directive)

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      UserMenu,
      MobileMenu
    },
    data () {
      return {
        inRedNotice: false,
        fullscreenLoading: false
      }
    },
    created () {
      this.$bus.$on('RedNotice', this.redNotice)
    },
    methods: {
      redNotice (show) {
        this.inRedNotice = show
      },
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    },
    computed: {
      // getAppIsLoading () {
      //   return this.$store.getters.isPending
      // }
    },
    watch: {
      // getAppIsLoading (value) {
      //   this.fullscreenLoading = value
      // }
    }
  }

</script>
<style>
  .redNotice {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999;
    background: rgb(255 0 0 / 50%);
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: 500;
    font-size: 20px;
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/DashboardLayout.vue